import './legend.css';
import React from 'react';

export default props => {
  return (
    <div style={{ ...styles.container, ...props.style }}>
      Legend:
      <ul className="legend" style={styles.list}>
        <li style={styles.listItem}>
          <MapPoint /> VR Tour
        </li>
        <li style={styles.listItem}>
          <MapPoint is360 /> 360 Photo
        </li>
        <li style={styles.listItem}>
          <MapPoint selected /> You are here
        </li>
      </ul>
    </div>
  );
};

const MapPoint = props => {
  return (
    <div
      style={{
        ...styles.mapPoint,
        background: props.is360
          ? '#3489de'
          : !props.selected
            ? '#ff5555'
            : '#33ff33'
      }}
    />
  );
};

const styles = {
  container: {
    display: 'inline',
    background: '#343434',
    padding: 10,
    color: '#ededed',
    fontSize: 10
  },
  list: {
    display: 'inline',
    listStyle: 'none',
    float: 'right',
    padding: 0,
    margin: 0
  },
  mapPoint: {
    display: 'inline-block',
    width: 10,
    minHeight: 10,
    minWidth: 10,
    height: 10,
    borderRadius: '100%'
  }
};



// WEBPACK FOOTER //
// ./src/components/Legend/Legend.js